$(document).ready(function() {
	$(window).on('action:ajaxify.end', function(data) {

		function setupHoverCards() {
			require(['components'], function(components) {
				components.get('topic')
					.on('click', '[component="user/picture-stream"],[component="user/status"]', generateUserCard);
			});

			$(window).on('action:posts.loading', function(ev, data) {
				for (var i = 0, ii = data.posts.length; i < ii; i++) {
					(ajaxify.data.topics || ajaxify.data.posts)[data.posts[i].index] = data.posts[i];
				}
			});
		}

		function generateUserCard(ev) {
			var avatar = $(this);
			var uid = avatar.parents('[data-uid]').attr('data-uid');

			var data = (ajaxify.data.topics);
			for (var i = 0, ii = data.length; i < ii; i++) {
				if (data[i] != undefined) {
					for (var i2 = 0, ii2 = data[i].posts.length; i2 < ii2; i2++) {
						if (parseInt(data[i].posts[i2].uid, 10) === parseInt(uid, 10)) {
							data = data[i].posts[i2].user;
							break;
						}
					}
				}
			}

			$('.persona-usercard').remove();

			if (parseInt(data.uid, 10) === 0) {
				return false;
			}

			socket.emit('user.isFollowing', { uid: data.uid }, function(err, isFollowing) {
				app.parseAndTranslate('modules/usercard', data, function(html) {
					var card = $(html);
					avatar.parents('a').after(card.hide());

					if (parseInt(app.user.uid, 10) === parseInt(data.uid, 10) || !app.user.uid) {
						card.find('.btn-morph').hide();
					} else {
						setupFavouriteMorph(card, data.uid, data.username);

						if (isFollowing) {
							$('.btn-morph').addClass('heart');
						} else {
							$('.btn-morph').addClass('plus');
						}
					}

					utils.makeNumbersHumanReadable(card.find('.human-readable-number'));
					setupCardRemoval(card);
					card.fadeIn();
				});
			});

			ev.preventDefault();
			return false;
		}

		function setupFavouriteButtonOnProfile() {
			setupFavouriteMorph($('[component="account/cover"]'), ajaxify.data.uid, ajaxify.data.username);
		}

		function setupCardRemoval(card) {
			function removeCard(ev) {
				if ($(ev.target).closest('.persona-usercard').length === 0) {
					card.fadeOut(function() {
						card.remove();
					});

					$(document).off('click', removeCard);
				}
			}

			$(document).on('click', removeCard);
		}

		function setupFavouriteMorph(parent, uid, username) {
			parent.find('.btn-morph').click(function(ev) {
				var type = $(this).hasClass('plus') ? 'follow' : 'unfollow';

				socket.emit('user.' + type, { uid: uid }, function(err) {
					if (err) {
						return app.alertError(err.message);
					}

					app.alertSuccess('[[global:alert.' + type + ', ' + username + ']]');
				});

				$(this).toggleClass('plus').toggleClass('heart');
				$(this).translateAttr('title', type === 'follow' ? '[[global:unfollow]]' : '[[global:follow]]');

				if ($(this).find('b.drop').length === 0) {
					$(this).prepend('<b class="drop"></b>');
				}

				var drop = $(this).find('b.drop').removeClass('animate'),
					x = ev.pageX - drop.width() / 2 - $(this).offset().left,
					y = ev.pageY - drop.height() / 2 - $(this).offset().top;

				drop.css({ top: y + 'px', left: x + 'px' }).addClass('animate');
			});
		}


		setupHoverCards();
	});
});